import {AppRoutesPrefixesEnum} from '../../../../../src/components/appRoutesPrefixes';
import {ActionWithPayload} from '../../../../../src/helpers/reduxHelpers';
import {findPanelSequence} from '../../../../../src/services/panels';
import {ThunkAction as AppThunkAction} from '../../../../../src/store/appThunk';
import {PanelActionPayload, setPanelAction} from '../../../../../src/store/panels/panelsActions';
import {getPanels} from '../../../../../src/store/panels/panelsSelectors';
import {KnowledgeBasePanelId, PanelTypesEnum} from '../../../../../src/store/panels/panelStateBase';
import {KnowledgeBaseParameters, KnowledgeBaseParametersTypesEnum} from '../knowledgeBaseParameters';

/*
 * Type enum.
 */

export enum KnowledgeBasePanelActionsEnum {
  NAVIGATED = '@@panels/knowledgeBase/NAVIGATED',
}

/*
 * Action Types.
 */

type KnowledgeBasePanelActionPayload = PanelActionPayload<KnowledgeBasePanelId>;

interface KnowledgeBaseNavigatedActionPayload extends KnowledgeBasePanelActionPayload {
  parameters: KnowledgeBaseParameters;
}

interface KnowledgeBaseNavigatedAction extends ActionWithPayload<KnowledgeBaseNavigatedActionPayload> {
  type: KnowledgeBasePanelActionsEnum.NAVIGATED;
}

export type KnowledgeBaseAction = KnowledgeBaseNavigatedAction;

/*
 * Actions.
 */

export function knowledgeBaseNavigatedAction(
  panelId: KnowledgeBasePanelId,
  parameters: KnowledgeBaseParameters,
): KnowledgeBaseNavigatedAction {
  return {
    type: KnowledgeBasePanelActionsEnum.NAVIGATED,
    payload: {panelId, parameters},
  };
}

// This returns an AppThunkAction instead of KnowledgeBaseThunkAction since it's used by the main app.
export function navigateKnowledgeBaseAction(
  panelId: KnowledgeBasePanelId,
  parameters: KnowledgeBaseParameters | undefined,
): AppThunkAction {
  return (dispatch, getState) => {
    const panel = getPanels(getState())[panelId];
    if (panel && panel.type !== PanelTypesEnum.KNOWLEDGE_BASE) {
      throw new Error('Wrong panel type.');
    }

    if (panel && parameters) {
      dispatch(knowledgeBaseNavigatedAction(panelId, parameters));
      return;
    }

    if (panel) {
      return;
    }

    dispatch(
      setPanelAction({
        id: panelId,
        type: PanelTypesEnum.KNOWLEDGE_BASE,
        sequence: findPanelSequence(),
        parameters: parameters ?? buildDefaultParameters(),
      }),
    );
  };
}

/*
 * Helpers.
 */

function buildDefaultParameters(): KnowledgeBaseParameters {
  return {
    type: KnowledgeBaseParametersTypesEnum.LIST,
    location: {
      pathname: `${AppRoutesPrefixesEnum.KNOWLEDGE_BASE}`,
    },
  };
}
